module.exports = __webpack_public_path__ + "img/Black-Box-img-cn-m.441358b1.png";